












































































































































































































































































import AppApiMixin from "@/components/mixins/AppApi.vue";
import FileInputMixin from "@/components/mixins/FileInputMixin.vue";
import {Component, Mixins, Watch} from "vue-property-decorator";
import Page from "@/components/for-page-grid/Page.vue";
import XNotice from "@/components/hoc/SimpleNotice.vue";
import CustomForm from "@/components/CustomForm.vue";
import SimpleButton from "@/components/SimpleButton.vue";
import {mapGetters, mapMutations, mapState} from "vuex";
import {AppealCustomFields, AppealTypes, AppealThemes} from "@/models/appeals";
import {AccountingPoint} from "@/models/accounting-point";
import {FieldTypes} from "@/assets/scripts/custom-fields/field-types";

@Component({
  components: {
    Page,
    XNotice,
    CustomForm,
    SimpleButton,
  },
  computed: {
    ...mapGetters("contract", {
      contractId: "id",
    }),
    ...mapGetters("user", {
      userEmail: "email",
    }),
    ...mapGetters("accountingPoints", {
      accountingPoints: "allPoints",
    }),
    ...mapGetters("appeals", {
      types: "types",
      themes: "themes",
      appealCustomFields: "appealCustomFields",
    }),
    ...mapState({ accountingPoint: "accountingPoint" }),
    ...mapGetters({
      sortedPointsByObject: "accountingPoints/sortedPointsByObject",
      orgContactAgent: "organization/agentList",
    }),
  },
  methods: {
    ...mapMutations("appeals", {
      setCustomFields: "setCustomFields",
    }),
  },
  data: () => ({
    requiredRule: [
      v => !!v || 'Заполните данное поле',
    ],
    emailRule: [
      v => !!v || 'Заполните данное поле',
      v => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || "Неправильный формат",
    ],
    phoneRule: [
      v => !!v || 'Заполните данное поле',
      v => {
        const endRegExp = "([- ]?\\d{2}){2}$";
        const phonePatterns = [
          new RegExp("^(\\d{4}|\\(\\d{4}\\))[- ]?\\d{2}" + endRegExp),
          new RegExp("^(\\d{3}|\\(\\d{3}\\))[- ]?\\d{3}" + endRegExp)
        ];
        return phonePatterns.some(pattern => pattern.test(v)) || "Неправильный формат";
      }
    ],
  }),
})
class AppealsAdd extends Mixins(AppApiMixin, FileInputMixin) {
  themeHint: string = "";

  appealTypes: [] = [];
  appealThemes: string[] = [];

  // массив категорий и видов обращений
  appealCategoriesArr: {[category_name: string]: number} = {};
  appealTypesArr: {[category_id: number]: any} = []; // [{[type_name: string]: number}]
  appealThemesArr: {[theme_name: string]: number} = {};

  accountingPointsArr: {[x: string]: number} = {};
  accountingPointsObjectsArr: {[x: string]: number} = {};

  customFields: AppealCustomFields[] = [];

  values: {[x: string]: any} = {};
  isFormValid = false;

  newFiles: File[] = [];
  fileList: File[] = [];
  submitSuccessText = "";
  submitErrorText = "";
  useSuccessAlert = false;
  useSubmitButtonLoading = false;
  formDisabled = false;
  fileError: string = "";
  filesValid: boolean = true;

  noAPointsForSelect = "Точки учета отсутствуют";

  mounted() {
    this.formDisabled = false;
    this.getAllAppealTypes();
    this.getAllAppealThemes();
    this.values['email'] = this.userEmail;
    // Получения данных о заявителе
    if (this.orgContactAgent != undefined) {
      if (Array.from(this.orgContactAgent).length > 0) {
        const agent = Array.from(this.orgContactAgent).shift();
        this.values['fio'] = agent['фио'] || "";
      }
    }

    // Инициализируем валидность файлов
    this.updateFilesValidity();
  }

  /**
   * ДАННЫЕ
   */

  /**
   * Список тем обращений
   */
  public get appealCategoriesForSelect() {
    const categories = this.types ? this.types.filter((theme) => theme['$папка'] == -10) : [];
    const categoriesNames = categories.map((name: AppealTypes) => name.название);
    const appealCategories_ids = categories.map((name: AppealTypes) => name.$номерЗаписи);

    categoriesNames.forEach((name, index) => {
      this.appealCategoriesArr[name] = appealCategories_ids[index];
    });

    const types = this.types ? this.types.filter((theme) => theme['$папка'] > 0) : [];
    const typesNames = types.map((name: AppealTypes) => name.название);
    const typesCategories = types.map((name: AppealTypes) => name.$папка);
    const typesIds = types.map((name: AppealTypes) => name.$номерЗаписи);

    typesNames.forEach((name, index) => {
      const category = typesCategories[index];
      if (this.appealTypesArr[category] == undefined) {
        this.appealTypesArr[category] = [];
      }
      this.appealTypesArr[category][name] = typesIds[index];
    });

    return [...categoriesNames];
  }

  /**
   * Список точек учета
   */
  public get accountingPointsForSelect() {
    const accountingPointsNames = this.accountingPoints ? this.accountingPoints.map((name: AccountingPoint) => name.названиету) : [];
    const accountingPointsIds = this.accountingPoints ? this.accountingPoints.map((name: AccountingPoint) => name.лицевой) : [];
    const accountingPointsObjectsIds = this.accountingPoints ? this.accountingPoints.map((name: AccountingPoint) => name.объект) : [];

    accountingPointsNames.forEach((item, index) => {
      this.accountingPointsArr[item] = accountingPointsIds[index];
      this.accountingPointsObjectsArr[item] = accountingPointsObjectsIds[index];
    });

    if (accountingPointsNames.length > 0) {
      return [...accountingPointsNames];
    } else {
      return [this.noAPointsForSelect];
    }
  }

  /**
   * СОБЫТИЯ
   */

  @Watch("appealCustomFields")
  public appealCustomFieldsChanged() {
    // очистка values от customFields
    for (let key in this.values) {
      if (key.startsWith('customFields[]')) {
        delete this.values[key];
      }
    }
    // набираем поля
    this.customFields = this.appealCustomFields;
    this.customFields.forEach((item, i) => {
      this.values['customFields[][' +item['id'] + ']'] = item;
    });

    // Обновляем валидность файлов
    this.updateFilesValidity();
  }

  /**
   * получение тем обращений
   */
  getThemes() {
    this.appealThemes = [];
    if (this.appealCategoriesArr[this.values['appealCategory']]) {
      let appealType = null;
      const category = this.appealCategoriesArr[this.values['appealCategory']];
      // получение записи
      const categoryObj: AppealTypes = this.types.filter((item) => item['$номерЗаписи'] == category)[0] || [];
      if (categoryObj['$этоПапка']) {
        // для папки смотрим второй уровень
        if (this.appealTypesArr[category] != undefined && this.appealTypesArr[category][this.values['appealType']]) {
          appealType = this.appealTypesArr[category][this.values['appealType']];
        }
      } else {
        appealType = category;
      }
      // корректная запись, получаем темы
      if (appealType != null) {
        const themes = this.themes ? this.themes.filter((theme) =>
          theme['видызаявок-видыобращений'] == appealType ||
          (appealType != category && theme['видызаявок-видыобращений'] == category)) : [];

        let themesArr: AppealThemes[] = [];
        themes.forEach((themeParent) => {
          const tmp = this.themes.filter((theme) => theme['$папка'] == themeParent['$номерЗаписи']);
          themesArr = themesArr.concat(tmp);
        });

        this.appealThemes = themesArr.map((name: AppealThemes) => name.название);
        const themesIds = themesArr.map((name: AppealThemes) => name.$номерЗаписи);

        this.appealThemes.forEach((name, index) => {
          this.appealThemesArr[name] = themesIds[index];
        });
      }
    }
  }

  /**
   * Изменение выбранной категории (уровень 1)
   */
  onSelectCategory() {
    this.themeHint = "";
    this.appealTypes = [];
    this.setCustomFields([]);
    if (this.values['appealCategory']) {
      // тема из категории
      const category = this.appealCategoriesArr[this.values['appealCategory']];
      const types = this.types ? this.types.filter((theme) => theme['$папка'] == category) : [];
      this.appealTypes = types.map((name: AppealTypes) => name.название);

      if (this.appealTypes.length == 0) {
        // это конечный вид
        this.getCustomFieldsData({
          typeId: this.appealCategoriesArr[category],
          themeId: this.appealThemesArr[this.values['appealTheme']] ?? null,
        });
        // подсказка
        this.themeHint = this.types.filter((theme) => theme['$номерЗаписи'] == category)[0]['подсказкалк'] || "";
      }
    }
    // набираем темы
    this.getThemes();
  }

  /**
   * Изменение выбранного вида обращения (уровень 2)
   */
  onSelectType() {
    this.setCustomFields([]);
    if (this.appealCategoriesArr[this.values['appealCategory']]) {
      const category = this.appealCategoriesArr[this.values['appealCategory']];
      if (this.appealTypesArr[category][this.values['appealType']]) {
        const type = this.appealTypesArr[category][this.values['appealType']];
        this.getCustomFieldsData({
          typeId: type,
          themeId: this.appealThemesArr[this.values['appealTheme']] ?? null,
        });
        // подсказка
        this.themeHint = this.types.filter((theme) => theme['$номерЗаписи'] == type)[0]['подсказкалк'] || "";
      }
    }
    // набираем вопросы
    this.getThemes();
  }

  /**
   * Изменение выбранной темы (уровень 3)
   */
  onSelectTheme() {
    let type = this.appealCategoriesArr[this.values['appealCategory']];
    if (this.appealTypesArr[type] != undefined) {
      type = this.appealTypesArr[type][this.values['appealType']];
    }
    this.getCustomFieldsData({
      typeId: type,
      themeId: this.appealThemesArr[this.values['appealTheme']] ?? null,
    });
  }

  /**
   * Добавление новых файлов
   */
  onFilesAdded(files: File[]) {
    if (files && files.length > 0) {
      // Добавляем новые файлы к существующим
      const existingFileNames = this.fileList.map(f => f.name);
      const uniqueNewFiles = files.filter(file =>
        !existingFileNames.includes(file.name)
      );

      if (uniqueNewFiles.length > 0) {
        this.fileList = [...this.fileList, ...uniqueNewFiles];
        this.validateFiles();
      }

      // Очищаем поле ввода
      this.newFiles = [];

      // Обновляем валидность файлов
      this.updateFilesValidity();
    }
  }

  /**
   * Удаление файла
   */
  removeFile(index: number) {
    this.fileList.splice(index, 1);
    // Создаем новый массив для реактивности
    this.fileList = [...this.fileList];
    this.validateFiles();

    // Обновляем валидность файлов
    this.updateFilesValidity();
  }

  /**
   * Удаление файла по имени
   */
  removeFileByFileName(fileName: string) {
    const index = this.fileList.findIndex(file => file.name === fileName);
    if (index !== -1) {
      this.removeFile(index);
    }
  }

  /**
   * Обновление валидности всех файлов
   */
  updateFilesValidity() {
    let isValid = true;

    // Проверяем кастомные поля типа FILE
    for (const field of this.customFields) {
      if (field['тип'] === FieldTypes.FILE && field['обязательное'] === 1) {
        const files = field['значение'];
        if (!files || !Array.isArray(files) || files.length === 0) {
          isValid = false;
          break;
        }
      }
    }

    this.filesValid = isValid;
  }

  /**
   * Обработчик изменения файлов в кастомных полях
   */
  onCustomFormFileChanged() {
    // Обновляем валидность файлов
    this.updateFilesValidity();
  }

  /**
   * Программный клик по полю ввода файлов
   */
  triggerFileInput() {
    // Можно добавить логику для программного клика
    // или оставить как есть, так как v-file-input сам обрабатывает клик
  }

  /**
   * Валидация файлов
   */
  validateFiles() {
    this.fileError = "";

    // Проверка на количество файлов
    if (this.fileList.length > 20) {
      this.fileError = "Прикреплено более 20 файлов";
      return false;
    }

    // Проверка каждого файла
    for (const file of this.fileList) {
      // Проверка размера файла (15MB = 15 * 1024 * 1024 bytes)
      const maxSize = this.getAppealsAcceptedFileSize() * 1024 * 1024;
      if (file.size > maxSize) {
        this.fileError = `Файл "${file.name}" превышает максимальный размер ${this.getAppealsAcceptedFileSize()}`;
        return false;
      }

      // Проверка расширения
      const allowedExtensions = ['jpeg', 'jpg', 'png', 'pdf', 'doc', 'docx', 'txt'];
      const extension = file.name.toLowerCase().split('.').pop();
      if (!extension || !allowedExtensions.includes(extension)) {
        this.fileError = `Файл "${file.name}" имеет недопустимое расширение. Допустимы: ${allowedExtensions.join(', ')}`;
        return false;
      }
    }

    return true;
  }

  public get areAllRequiredFilesValid(): boolean {
    // Проверяем основные файлы (если они обязательны - но в вашем коде они не обязательны)
    // Основные файлы не обязательны, так что пропускаем

    // Проверяем кастомные поля типа FILE
    for (const field of this.customFields) {
      if (field['тип'] === FieldTypes.FILE && field['обязательное'] === 1) {
        const files = field['значение'];
        if (!files || !Array.isArray(files) || files.length === 0) {
          return false; // Обязательное файловое поле не заполнено
        }
      }
    }

    return true;
  }

  public get isSubmitDisabled(): boolean {
    return !this.isFormValid ||
      !this.filesValid ||
      this.useSubmitButtonLoading ||
      this.formDisabled;
  }

  /**
   * Отправка обращения
   */
  async submitForm() {
    this.useSuccessAlert = false;
    this.useSubmitButtonLoading = true;
    this.fileError = "";

    // Проверяем обязательные файловые поля
    let hasFileErrors = false;
    this.customFields.forEach((field) => {
      if (field['тип'] === FieldTypes.FILE) {
        // Проверяем обязательные файловые поля
        if (field['обязательное'] === 1 && (!field['значение'] || field['значение'].length === 0)) {
          this.fileError = `Поле "${field['название']}" обязательно для заполнения`;
          hasFileErrors = true;
        }
      }
    });

    if (hasFileErrors) {
      this.useSubmitButtonLoading = false;
      return;
    }

    const formData = new FormData();

    // Проверка всех файлов (основных и кастомных)
    const allFiles = [...this.fileList];

    // Добавляем файлы из кастомных полей
    this.customFields.forEach((field) => {
      if (field['тип'] === FieldTypes.FILE && field['значение']) {
        allFiles.push(...field['значение']);
      }
    });

    if (allFiles.length > this.getAppealsAvailableCount()) {
      this.fileError = "Прикреплено более " + this.getAppealsAvailableCount() + " файлов";
      this.useSubmitButtonLoading = false;
      return;
    }

    for (let key in this.values) {
      switch (key) {
        case "appealTheme":
          if (this.values[key] != "" && this.appealThemesArr && this.appealThemesArr[this.values[key]]) {
            formData.append(key, this.appealThemesArr[this.values[key]].toString());
          }
          break;
        case "accountingPoint":
          if (this.values[key] != "" && this.accountingPointsArr && this.accountingPointsArr[this.values[key]]) {
            formData.append(key, this.accountingPointsArr[this.values[key]].toString());
          }
          break;
        default:
          if (key.indexOf('customFields') < 0 && key != "appealCategory" && key != "appealType") {
            formData.append(key, this.values[key]);
          }
          break;
      }
    }

    // Добавляем основные файлы
    if (this.fileList.length > 0) {
      for (let file of this.fileList) {
        formData.append("file[]", file);
      }
    }

    let appealType = this.appealCategoriesArr[this.values['appealCategory']];
    if (this.values['appealType']) {
      const type = this.values['appealType'];
      if (this.appealTypesArr[appealType][type]) {
        appealType = this.appealTypesArr[appealType][type];
      }
    }
    formData.append('appealType', appealType.toString());

    // кастомные поля
    if (this.customFields.length > 0) {
      for (let key in this.customFields) {
        const field = this.customFields[key];
        const parameterId = field['id'].toString();

        if (field['тип'] === FieldTypes.FILE) {
          const files = field['значение'] || [];

          if (files.length > 0) {
            // Для текстовых данных
            for (let i = 0; i < files.length; i++) {
              formData.append(`appealCustom[${key}][${i}][параметр]`, parameterId);
              formData.append(`appealCustom[${key}][${i}][значение]`, files[i].name); // Только имя файла
              formData.append(`appealCustom[${key}][${i}][идФайл]`, '');
            }

            // Для файлов передаем отдельно
            for (let i = 0; i < files.length; i++) {
              formData.append(`appealCustomFiles[${key}][${i}]`, files[i]);
            }
          }
        } else if (field['тип'] === FieldTypes.COMBOBOX && field['значение']) {
          formData.append(`appealCustom[${key}][параметр]`, parameterId);

          let bitMask = 0;
          field['значение'].split(';').forEach((el, i) => {
            if(field['возможныеЗначения'].split(';').includes(el)) {
              bitMask += Math.pow(2, i);
            }
          });
          formData.append(`appealCustom[${key}][значение]`, bitMask.toString());

          if (field['свойвариант']) {
            formData.append(`appealCustom[${key}][свойвариант]`, field['свойвариант']);
          }
        } else if (field['тип'] === FieldTypes.RANGE && field['значение']) {
          formData.append(`appealCustom[${key}][параметр]`, parameterId);
          formData.append(`appealCustom[${key}][значение]`,
            field['значение'][0].split('T')[0].split('-').reverse().join('.')
            + '-' + field['значение'][1].split('T')[0].split('-').reverse().join('.'));
        } else if (field['тип'] === FieldTypes.MONTH && field['значение']) {
          formData.append(`appealCustom[${key}][параметр]`, parameterId);
          let date = field['значение'].split('T')[0].split('-');
          formData.append(`appealCustom[${key}][значение]`, date[1] + '.' + date[0]);
        } else if (field['тип'] === FieldTypes.DATE && field['значение']) {
          formData.append(`appealCustom[${key}][параметр]`, parameterId);
          let date = field['значение'].split('T')[0].split('-');
          formData.append(`appealCustom[${key}][значение]`, date[2] + '.' + date[1] + '.' + date[0]);
        } else {
          formData.append(`appealCustom[${key}][параметр]`, parameterId);
          const value = field['значение'] || field['поУмолчанию'] || '';
          formData.append(`appealCustom[${key}][значение]`, value);
        }
      }
    }

    formData.append('contractId', this.contractId.toString());

    try {
      const data = await this.sendAppeal(formData);

      if (data && data.result && (data.appealId) != 0) {
        this.submitSuccessText = "Обращение успешно отправлено";
        this.useSuccessAlert = true;

        // блокируем форму от повторных нажатий
        this.formDisabled = true;

        setTimeout(() => (this.$router.push({ name: "appealsByContract", params: { contractId: this.contractId } })), 2000);
      }

    } catch (e) {
      this.submitErrorText = e.data;
    }
    this.submitSuccessText = "";
    this.useSubmitButtonLoading = false;
  }
}

export default AppealsAdd

